import { Helmet } from "react-helmet";

const faqs = [
  {
    q: "What is SurpriseTable?",
    a: "SurpriseTable is a unique dining experience where you book a meal at a fixed price, share your preferences, and we match you with a top restaurant in your city. The twist? You only discover the restaurant on the day of your booking."
  },
  {
    q: "How does the surprise work?",
    a: "You select your date, time, location, and dietary needs. We partner with great local restaurants who craft a chef-selected menu, always valued higher than what you pay. Your actual restaurant is revealed just before your meal."
  },
  {
    q: "Is my €15 booking fee really enough for a premium meal?",
    a: "Absolutely! Your €15 is credited toward a special menu curated by the restaurant, and the value of your meal is guaranteed to exceed what you paid. You may pay the difference for extra drinks or dishes."
  },
  {
    q: "Can I choose the type of cuisine or restaurant?",
    a: "You can specify dietary restrictions and some cuisine preferences. However, the restaurant selection remains a surprise to maximize discovery and excitement. We only match you with trusted partners."
  },
  {
    q: "When do I find out which restaurant I've been matched with?",
    a: "You’ll receive the restaurant name, address, and reservation details on the day of your booking, typically a few hours before your scheduled time."
  },
  {
    q: "Can I book for a group?",
    a: "Yes! Just indicate the number of guests during booking. We accommodate groups up to 8 people. For larger parties or special events, contact us directly."
  },
  {
    q: "What if I have dietary restrictions or allergies?",
    a: "We take this seriously. You can list all allergies and restrictions during booking, and your matched restaurant will craft a safe, delicious menu accordingly."
  },
  {
    q: "How do payments work?",
    a: "You pay €15 per person to secure your reservation. This is credited toward your final bill at the restaurant. Any additional food or drinks are paid directly at the venue."
  },
  {
    q: "What if I need to cancel my booking?",
    a: "You can cancel up to 24 hours in advance for a full refund. Cancellations less than 24 hours before the meal may not be refundable, as restaurants prepare your menu in advance."
  },
  {
    q: "Is my payment secure?",
    a: "Yes, all payments are processed using industry-standard encryption. Your data and payment info are fully protected."
  },
  {
    q: "Can I request a specific restaurant?",
    a: "No, the core of SurpriseTable is discovery! However, we only work with vetted partners and always match you with a high-quality venue."
  },
  {
    q: "Can I refer friends and earn rewards?",
    a: "Yes! Use your referral code to invite friends. For every friend who completes a booking, you earn €10 SurpriseTable credit."
  },
  {
    q: "What if I don’t like my surprise restaurant?",
    a: "We select only reputable, well-rated restaurants. If your experience falls short, let us know. We’re committed to making it right."
  },
  {
    q: "What kind of restaurants do you partner with?",
    a: "All our partner restaurants are handpicked for quality, service, and creativity. We work with everything from cozy bistros to high-end venues. Each meal is special."
  },
  {
    q: "How far in advance should I book?",
    a: "Bookings are best made at least 24 hours in advance, especially for weekends or larger groups."
  },
  {
    q: "What should I bring to the restaurant?",
    a: "Just show your SurpriseTable booking confirmation (on your phone is fine). The restaurant will take care of the rest."
  },
  {
    q: "Can I share feedback after my meal?",
    a: "Definitely! After dining, you’ll receive an invitation to rate your experience. Your feedback helps us improve and reward our partner restaurants."
  },
  {
    q: "What if I want to book regularly?",
    a: "Regulars enjoy surprise perks and exclusive access to new restaurant partners. Book more often to unlock premium benefits!"
  },
  {
    q: "Can I use SurpriseTable for business or special occasions?",
    a: "Absolutely. SurpriseTable is perfect for unique dates, business dinners, birthdays, and group events. Contact us for bespoke arrangements."
  },
  {
    q: "Is there a loyalty program?",
    a: "Yes! The more you book, the more you earn. You get exclusive discounts, access to VIP experiences, and bonus credits for referring friends."
  },
  {
    q: "Still have questions?",
    a: "Contact our team at support@surprisetable.com or through the in-app chat. We’re here to help!"
  }
];

const FAQ = () => {
  return (
      <>
        <Helmet>
          <title>Frequently Asked Questions | SurpriseTable</title>
          <meta
              name="description"
              content="Find answers to common questions about SurpriseTable. Learn how bookings, payments, and the surprise experience work."
          />
        </Helmet>
        <section className="bg-white py-16 transition-colors duration-200 dark:bg-gray-900">
          <div className="container mx-auto px-4 max-w-4xl">
            <div className="mb-12 text-center">
              <h1 className="mb-4 font-serif text-4xl font-bold text-gray-800 dark:text-white">
                Frequently Asked Questions
              </h1>
              <p className="mx-auto max-w-2xl text-lg text-gray-600 dark:text-gray-300">
                Got questions about SurpriseTable? See answers below. Still need help? <a href="mailto:support@surprisetable.com" className="text-primary hover:underline">Contact us</a>.
              </p>
            </div>
            <div className="space-y-8">
              {faqs.map((item, idx) => (
                  <div key={idx} className="rounded-xl bg-gray-50 p-6 shadow dark:bg-gray-800">
                    <h2 className="mb-3 text-xl font-semibold text-primary dark:text-primary-dark">{item.q}</h2>
                    <p className="text-gray-700 dark:text-gray-200">{item.a}</p>
                  </div>
              ))}
            </div>
          </div>
        </section>
      </>
  );
};

export default FAQ;
